import { render, staticRenderFns } from "./ChoiceInput.vue?vue&type=template&id=1107a536&scoped=true"
import script from "./ChoiceInput.vue?vue&type=script&lang=ts"
export * from "./ChoiceInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1107a536",
  null
  
)

export default component.exports